import script from "./AlarmDescriptionCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlarmDescriptionCell.vue?vue&type=script&setup=true&lang=ts"

import "./AlarmDescriptionCell.vue?vue&type=style&index=0&id=14aa6dc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14aa6dc8"]])

export default __exports__